import React from "react";

function ReportExplanationText() {
  return (
    <>
      <p>
        A profit and loss statement summarizes and organizes your business
        revenue and expenses. The first part of the P&L includes income
        (revenue/sales/refunds) and cost of sales.
      </p>
      <p>
        Cost of sales groups the expenses that are directly related with your
        sales process/core business. This includes the cost of inventory that
        sold, transaction fees, shipping costs, etc. The reason a P&L groups
        these costs is to help you manage your business. By combining the costs
        directly associated with how you make money, you can see how profitable
        your sales process is. Income minus cost of sales equals gross profit.
      </p>
      <p>
        The next section of the P&L includes gross profit and other business
        expenses. Other business expenses are your business expenses that don’t
        directly relate to your sales process. Subtracting other business
        expenses from gross profit gives you your operating profit. Operating
        profit is the total amount that you take home after expenses.
      </p>
      <p>
        Finally, if you subtract taxes and interest from your operating profit,
        you obtain your net profit.
      </p>
    </>
  );
}

export default ReportExplanationText;
